const formatProductPlanPrice = (price?: number): string => {
  if (!price) {
    return '';
  }

  const AudDollar = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });

  return AudDollar.format(Math.round(price));
};

export { formatProductPlanPrice };
